var __jsx = React.createElement;
import { BREAKPOINTS } from '@lib/constants';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
const HideFromBreakpointDiv = _ref => {
  let {
    children,
    breakpoint
  } = _ref;
  const isWithinBreakpoint = useMediaQuery({
    maxWidth: "".concat(BREAKPOINTS[breakpoint], "px")
  });
  return isWithinBreakpoint ? __jsx(React.Fragment, null, children) : null;
};
export default HideFromBreakpointDiv;